import { render, staticRenderFns } from "./VoucherTypeButtons.vue?vue&type=template&id=0b85e5de&"
import script from "./VoucherTypeButtons.vue?vue&type=script&lang=js&"
export * from "./VoucherTypeButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b85e5de')) {
      api.createRecord('0b85e5de', component.options)
    } else {
      api.reload('0b85e5de', component.options)
    }
    module.hot.accept("./VoucherTypeButtons.vue?vue&type=template&id=0b85e5de&", function () {
      api.rerender('0b85e5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/VoucherTypeButtons.vue"
export default component.exports